import { axiosService } from '..';

export default class UpdateBusinessFrontPageClaimsAndMainImageService {
    public async execute(input: UpdateBusinessFrontPageClaimsAndMainImageInputDto): Promise<void> {
        const requestBodyData = new FormData();

        if (input.claim) {
            requestBodyData.append('claim', input.claim);
        }

        if (input.subClaim) {
            requestBodyData.append('subclaim', input.subClaim);
        }

        if (input.mainImage) {
            requestBodyData.append(input.mainImage.name, input.mainImage);
        }
        await axiosService.instance.post(`businesses/organization/front-page/${input.businessId}/update-claims-and-main-image`, requestBodyData, { headers: { 'Content-Type': 'multipart/form-data' } });
    }
}

export class UpdateBusinessFrontPageClaimsAndMainImageInputDto {
    public readonly businessId: number;
    public readonly claim?: string;
    public readonly subClaim?: string;
    public readonly mainImage?: File | null;

    constructor(businessId: number, claim?: string, subClaim?: string, mainImage?: File | null) {
        this.businessId = businessId;
        this.claim = claim;
        this.subClaim = subClaim;
        this.mainImage = mainImage;
    }
}

export const updateBusinessFrontPageClaimsAndMainImageService = new UpdateBusinessFrontPageClaimsAndMainImageService();
